import isArrayLike from './is-array-like';
export default (function (value) {
    return isArrayLike(value) ? Array.prototype.slice.call(value) : [];
});
//# sourceMappingURL=to-array.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/lodash/to-array.js
// module id = null
// module chunks = 